export const formatPrice = (priceInPaisa) => {
  if (priceInPaisa === undefined || priceInPaisa === null || priceInPaisa === "") {
    return "0.00";
  }

  const numericValue = Number(priceInPaisa);

  if (Number.isNaN(numericValue)) {
    return "0.00";
  }

  const rupeeValue = numericValue / 100;

  return rupeeValue.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};


